import { ServiceProviderType } from './service-provider-type.enum';

export class Service {
  public title: string;
  public description: string;
  public type: ServiceProviderType;
  public tags: Array<string>;
  public locations: Array<string>;
  public imageId: string;
  public userId: string;
  constructor() {}
}
